module.exports = __webpack_public_path__ + "static/media/bg-auth3.f2bb51f6.png";